import * as types from './actionTypes';
import Resource from "../services/PrivateAPIResource";

export function getProductSuccess(product) {
    return {type: types.GET_PRODUCT_SUCCESS, product};
}

export function loadProductsSuccess(products) {
    return {type: types.LOAD_PRODUCTS_SUCCESS, products};
}

export function createProductSuccess(product) {
    return {type: types.CREATE_PRODUCT_SUCCESS, product};
}

export function deleteProductSuccess(id) {
    return {type: types.DELETE_PRODUCT_SUCCESS, id};
}

export function cloneProductSuccess(product) {
    return {type: types.CLONE_PRODUCT_SUCCESS, product};
}

export function getProduct(id) {
    return function (dispatch) {
        return Resource.get('products', id).then(product => {
            dispatch(getProductSuccess(product))
        }).catch(error => {
            throw  error;
        });
    }
}

export function updateProduct(product, id) {
    return function (dispatch, getState) {
        return Resource.update('products', id, product, true).then(product => {
            dispatch(createProductSuccess(product));
        }).catch(error => {
            throw error;
        })
    }
}

export function loadProducts(page, sortParams) {
    return function (dispatch) {
        return Resource.get('products?page='+page, null, sortParams).then(products => {
            dispatch(loadProductsSuccess(products));
        }).catch(error => {
            throw error;
        });
    }
}

export function deleteProduct(id) {
    return function (dispatch) {
        return Resource.remove('products', id).then(product => {
            dispatch(deleteProductSuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}

export function saveProduct(product) {
    return function (dispatch, getState) {
        return Resource.create('products', product, true).then(product => {
            dispatch(createProductSuccess(product));
        }).catch(error => {
            throw error;
        })
    }
}

export function cloneProduct(id) {
    return function (dispatch) {
        return Resource.get('products/clone', id).then(product => {
            dispatch(cloneProductSuccess(product))
        }).catch(error => {
            throw  error;
        });
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/productsActions.js